var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4254.23,-2.37891 H 0 V 4252 H 4254.23 V -2.37891",
    style: {
      fill: "#ec1b2e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 593.977,3692.48 h 1.261 V 3035.85 H 739.43 v 857.79 H 624.281 L 491.48,3738.02 v -150.51 h 1.262 l 101.235,104.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3276.31,2222.28 c 0,65.11 52.79,117.82 117.85,117.82 64.96,0 117.6,-52.71 117.6,-117.82 0,-65.05 -52.64,-117.79 -117.6,-117.79 -65.06,0 -117.85,52.74 -117.85,117.79",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3531.64,2059.08 c 79.9,-7.23 142.53,-74.44 142.53,-156.41 v -39.14 -17.12 -270.23 c 0,-25.1 -20.44,-45.63 -45.59,-45.63 -25.33,0 -45.69,20.53 -45.69,45.63 v 280.4 c 0,10.53 -3.05,24.76 -22.28,24.76 -13.3,0 -16.06,-14.1 -16.56,-23.07 v -840.43 c 0,-36.11 -29.25,-65.59 -65.54,-65.59 -36.33,0 -65.73,29.48 -65.73,65.59 v 484.32 c -0.18,5.34 -1.96,19.23 -18.62,19.23 h -0.07 c -16.74,0 -18.78,-13.89 -18.95,-19.23 v -484.32 c 0,-36.11 -29.23,-65.59 -65.53,-65.59 -36.37,0 -65.63,29.48 -65.63,65.59 v 840.43 c -0.44,8.97 -3.3,23.07 -16.49,23.07 -19.34,0 -22.26,-14.23 -22.26,-24.76 v -280.4 c 0,-25.1 -20.47,-45.63 -45.69,-45.63 -25.25,0 -45.59,20.53 -45.59,45.63 v 270.23 17.12 39.14 c 0,81.97 62.68,149.18 142.71,156.41 2.61,0.34 5.47,0.72 8.62,0.72 h 128.88 128.52 c 3.38,0 6.14,-0.38 8.96,-0.72",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2575.94,2160.42 c 0,61.6 -49.8,111.65 -111.42,111.65 -61.65,0 -111.58,-50.05 -111.58,-111.65 0,-61.62 49.93,-111.54 111.58,-111.54 61.62,0 111.42,49.92 111.42,111.54",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2239.78,1907.79 -92.7,-301.8 c 0,0 -16.53,-55.33 30.41,-69.14 46.7,-13.83 60.87,40.19 60.87,40.19 l 74.76,251.88 c 0,0 4.06,19.37 18.62,15.18 14.59,-4.17 9.11,-24.9 9.11,-24.9 l -130.11,-472.04 h 121 v -338.09 c 0,-31.988 26.05,-58.031 58.17,-58.031 32.06,0 58.01,26.043 58.01,58.031 v 338.09 h 16.6 16.42 v -338.09 c 0,-31.988 25.89,-58.031 58.06,-58.031 32.19,0 58.19,26.043 58.19,58.031 v 338.09 h 120.95 l -130.01,472.04 c 0,0 -5.47,20.73 9.06,24.9 14.59,4.19 18.64,-15.18 18.64,-15.18 l 74.74,-251.88 c 0,0 14.22,-54.02 60.85,-40.19 47.04,13.81 30.44,69.14 30.44,69.14 l -92.71,301.8 c 0,0 -33.12,87.25 -106.49,87.25 h -118.14 -118.19 c -73.35,0 -106.55,-87.25 -106.55,-87.25",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1907.98,2160.42 c 0,61.6 -49.88,111.65 -111.48,111.65 -61.65,0 -111.52,-50.05 -111.52,-111.65 0,-61.62 49.87,-111.54 111.52,-111.54 61.6,0 111.48,49.92 111.48,111.54",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1571.76,1907.79 -92.65,-301.8 c 0,0 -16.58,-55.33 30.39,-69.14 46.67,-13.83 60.85,40.19 60.85,40.19 l 74.76,251.88 c 0,0 4.06,19.37 18.62,15.18 14.61,-4.17 9.08,-24.9 9.08,-24.9 l -130.06,-472.04 h 120.98 v -338.09 c 0,-31.988 26.12,-58.031 58.16,-58.031 32.12,0 58.06,26.043 58.06,58.031 v 338.09 h 16.66 16.36 v -338.09 c 0,-31.988 25.85,-58.031 58.09,-58.031 32.2,0 58.11,26.043 58.11,58.031 v 338.09 h 121.01 l -129.99,472.04 c 0,0 -5.52,20.73 8.98,24.9 14.57,4.19 18.67,-15.18 18.67,-15.18 l 74.69,-251.88 c 0,0 14.23,-54.02 60.88,-40.19 47.01,13.81 30.41,69.14 30.41,69.14 l -92.71,301.8 c 0,0 -33.04,87.25 -106.44,87.25 h -118.06 -118.27 c -73.32,0 -106.58,-87.25 -106.58,-87.25",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2950.5,1536.23 c 51.35,0 92.79,41.56 92.79,92.92 0,51.32 -41.44,92.75 -92.79,92.75 -51.35,0 -92.84,-41.43 -92.84,-92.75 0,-51.36 41.49,-92.92 92.84,-92.92",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2727.93,1247.84 c -4.55,-10.85 -8.26,-33.87 13.53,-43.91 25.56,-11.73 39.78,12.96 39.78,12.96 l 50.47,160.93 c 0,0 8.75,10.78 8.75,-0.36 V 998.609 h 0.24 c 0,-26.371 21.22,-47.64 47.63,-47.64 26.33,0 47.61,21.269 47.61,47.64 v 149.501 c 0,0 -2.77,21.14 14.27,21.14 17.04,0 14.41,-21.14 14.41,-21.14 V 998.609 c 0,-26.371 21.38,-47.64 47.71,-47.64 26.28,0 47.73,21.269 47.73,47.64 v 378.851 c 0,11.14 5.89,3.19 5.89,3.19 l 39.55,-110.2 c 0,0 17.17,-49.25 22.46,-51.42 17.84,-7.5 38.47,1.02 46.01,19.03 4.93,11.75 3.05,24.36 -3.77,33.87 l 0.33,0.35 c -1.13,3.56 -59.11,145.75 -65.93,165.71 -20.94,61.12 -59.04,60.59 -95.73,61.6 -36.71,0.87 -58.66,0 -58.66,0 0,0 -23.44,0.95 -71.9,-0.48 -48.35,-1.52 -63.64,-26.31 -117,-163.6 -7.61,-19.78 -33.38,-83.75 -33.72,-87.59 l 0.34,-0.08",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 911.965,2222.28 c 0,65.11 -52.848,117.82 -117.883,117.82 -64.984,0 -117.621,-52.71 -117.621,-117.82 0,-65.05 52.637,-117.79 117.621,-117.79 65.035,0 117.883,52.74 117.883,117.79",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 656.582,2059.08 c -79.879,-7.23 -142.59,-74.44 -142.59,-156.41 v -39.14 -17.12 -270.23 c 0,-25.1 20.473,-45.63 45.696,-45.63 25.25,0 45.671,20.53 45.671,45.63 v 280.4 c 0,10.53 3.043,24.76 22.282,24.76 13.265,0 16.031,-14.1 16.597,-23.07 v -840.43 c 0,-36.11 29.2,-65.59 65.524,-65.59 36.273,0 65.597,29.48 65.597,65.59 v 484.32 c 0.289,5.34 2.043,19.23 18.723,19.23 h 0.051 c 16.73,0 18.773,-13.89 18.926,-19.23 v -484.32 c 0,-36.11 29.277,-65.59 65.55,-65.59 36.348,0 65.602,29.48 65.602,65.59 v 840.43 c 0.383,8.97 3.379,23.07 16.547,23.07 19.336,0 22.226,-14.23 22.226,-24.76 v -280.4 c 0,-25.1 20.476,-45.63 45.696,-45.63 25.23,0 45.62,20.53 45.62,45.63 v 270.23 17.12 39.14 c 0,81.97 -62.66,149.18 -142.695,156.41 -2.656,0.34 -5.468,0.72 -8.644,0.72 H 794.082 665.566 c -3.382,0 -6.195,-0.38 -8.984,-0.72",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 553.883,1528.73 449.297,974.379",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 34.5458,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1130.22,1584.87 c -6.09,9.52 -16.58,15.87 -28.66,15.87 -18.64,0 -33.82,-15.18 -33.82,-33.74 0,-5.4 3.3,-14.85 3.3,-14.85 l 93.59,-169.36 c 0,0 5.74,-11.67 5.74,-22.33 V 996.789 h 0.18 c 0,-25.379 20.47,-45.75 45.77,-45.75 25.25,0 45.61,20.371 45.61,45.75 v 143.521 c 0,0 -2.57,20.3 13.82,20.3 16.34,0 13.79,-20.3 13.79,-20.3 V 996.789 c 0,-25.379 20.52,-45.75 45.8,-45.75 25.25,0 45.82,20.371 45.82,45.75 v 363.671 c 0,10.66 5.66,22.33 5.66,22.33 l 86.51,156.35 c 0,0 10.58,22.46 10.58,27.86 0,18.56 -15.13,33.74 -33.85,33.74 -12.23,0 -22.69,-6.35 -28.62,-15.87 l -0.39,0.2 c -2.72,-2.34 -46.04,-79.49 -60.34,-93.78 -15.12,-15.25 -28.65,-13.56 -28.65,-13.56 h -56.31 -56.18 c 0,0 -13.63,-1.69 -28.68,13.56 -14.48,14.29 -57.63,91.44 -60.39,93.78 l -0.28,-0.2",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1275.75,1536.23 c 51.35,0 92.79,41.56 92.79,92.92 0,51.32 -41.44,92.75 -92.79,92.75 -51.33,0 -92.79,-41.43 -92.79,-92.75 0,-51.36 41.46,-92.92 92.79,-92.92",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1275.9,1405.94 104.93,-76.53 49.84,-183.58 H 1121 l 49.99,183.58 104.91,76.53",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1279.61,3721.14 v -174.87 h -60.41 v 359.29 h 60.41 v -157.92 l 65.72,157.92 h 59.35 l -69.95,-161.63 71.54,-197.66 h -63.59 l -63.07,174.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1426.43,3905.56 h 144.14 v -49.28 h -83.73 v -102.8 h 59.88 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1600.26,3905.56 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1743.88,3772.02 v -225.75 h -50.87 v 359.29 h 59.35 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1899.71,3905.56 h 144.14 v -49.28 h -83.73 v -102.8 H 2020 v -48.76 h -59.88 v -109.17 h 83.73 v -49.28 h -144.14 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1285.44,3160.2 h 48.23 l -23.85,144.15 h -0.53 z m -75.78,-113.93 67.84,359.29 h 68.89 l 68.36,-359.29 h -62.01 l -11.12,65.71 h -64.12 l -10.61,-65.71 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1497.44,3356.28 v -111.81 h 20.13 c 20.67,0 29.68,10.59 29.68,29.67 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.2 v -164.81 h -60.42 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.1 c 0,-38.69 -13.78,-61.47 -48.22,-69.42 l 57.76,-163.22 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1804.82,3279.44 h -1.58 l -40.81,-233.17 h -28.09 l -45.04,233.17 h -1.06 v -233.17 h -49.82 v 359.29 h 70.49 l 39.21,-202.43 h 0.53 l 34.98,202.43 h 76.31 v -359.29 h -55.12 v 233.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2067.16,3405.56 v -271.85 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 v -277.68 c 0,-21.2 8.47,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2092.09,3405.56 h 160.58 v -49.28 h -49.82 v -310.01 h -60.94 v 310.01 h -49.82 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe01);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-01.2b0af8ca4fdc0820987ad3e967548a02.svg";
export { ForwardRef as ReactComponent };